import { PaginationOptions } from 'types';

export const DEFAULT_PAGINATION: PaginationOptions = {
  page: 1,
  take: 10,
};

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100];

/**
 * The standard sizes plus 150, so a full 150-order batch fits on one page. A superset, not a
 * replacement: pagination is shared across a section's tabs, and dropping the standard sizes
 * would leave a value carried over from a neighbour tab outside the selector's options.
 */
export const BULK_ROWS_PER_PAGE_OPTIONS = [
  ...DEFAULT_ROWS_PER_PAGE_OPTIONS,
  150,
];

export const BULK_DEFAULT_PAGINATION: PaginationOptions = {
  page: 1,
  take: 50,
};
